
// import custom SCSS
import './main.scss';
import AccessibleMenu from "./js/accessibleMenu";
import sticky from "./js/sticky";

// Initialization for ES Users
import {
  Collapse,
  Offcanvas,
  initTE,
} from "tw-elements";

initTE({ Collapse, Offcanvas });

// Initialize AccessibleMenu
window.addEventListener('load', () => {
  document
    .querySelectorAll('.accessible-menu')
    .forEach((item) => {
      const menu = new AccessibleMenu(item);
      menu.init();
  });
});
